module.exports = __webpack_public_path__ + "static/media/logo-mobile-view.b53cf038.svg";